import AssistantPage from './components/AssistantPage';

export default AssistantPage;
